import { render, staticRenderFns } from "./EditarApresentacao.vue?vue&type=template&id=78657fb6&scoped=true&"
import script from "./EditarApresentacao.vue?vue&type=script&lang=js&"
export * from "./EditarApresentacao.vue?vue&type=script&lang=js&"
import style0 from "./EditarApresentacao.vue?vue&type=style&index=0&id=78657fb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78657fb6",
  null
  
)

export default component.exports